const getPeakLoading = (
  peakSheet: any,
  demographic: any,
  selectedPeak: number
): number | null => {
  // Retrieve the row index
  const rowIndex = peakSheet.findIndex(
    (rowArray: any[]) => rowArray[0] === demographic
  );

  if (rowIndex === -1) {
    return null;
  }

  // Retrieve the header index
  const headers = peakSheet[0];
  const columnIndex = headers.findIndex(
    (header: any) => header === selectedPeak
  );

  if (columnIndex === -1) {
    return null;
  }

  // Retrieve the loading percentage
  const value = peakSheet[rowIndex][columnIndex];

  return typeof value === 'number' ? value : null;
};

export default getPeakLoading;
